import { css } from '@emotion/react';

import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import Button from 'components/field/Button';
import LottiePlayer from 'components/global/LottiePlayer';
import Typography from 'components/global/Typography';
import { ModalActions } from 'components/global/styled/Modal.styled';

import fetchRoles from 'services/common/fetchRoles';
import fetchUserDetails from 'services/common/fetchUserDetails';

import * as S from '../SubscriptonAccountModal.styled';

/**
 * @author @muhammedburakak
 */

export default function CompletedModal({ closeModal, prevStep, subscription, renewSubscription }) {
	const { t } = useTranslation();

	const { status } = useSelector((state) => state?.subscriptionAccount.paymentResult ?? {});

	const currentPlanName = useSelector((state) => state.user.planName);

	const animations = { failed: 'payment-failed', paid: 'payment-success', pending: 'success' };

	const animationName = animations[status] ?? 'success';

	useEffect(() => {
		if (status !== 'failed') {
			fetchUserDetails();
			fetchRoles();
		}
	}, [status]);

	return (
		<>
			<S.ModalContentWrapper>
				<S.CompletedContainer>
					<LottiePlayer name={animationName} height="300px" width="300px" />

					{subscription && (
						<>
							{status === 'failed' && (
								<Typography variant="p1" fontWeight="500" noWrap>
									subscriptionFailedText
								</Typography>
							)}

							{(status === 'paid' || status === 'upgraded') && (
								<Typography variant="p1" fontWeight="500" noWrap>
									{t('subscriptionSuccessText', {
										currentPackageName: t(`${currentPlanName}.packageTitle`)
									})}
								</Typography>
							)}
						</>
					)}

					{renewSubscription && (
						<>
							{status === 'failed' && (
								<Typography variant="p1" fontWeight="500" noWrap>
									renewSubscriptionFailedText
								</Typography>
							)}

							{status === 'paid' && (
								<Typography variant="p1" fontWeight="500" noWrap>
									renewSubscriptionSuccessText
								</Typography>
							)}
						</>
					)}
				</S.CompletedContainer>
			</S.ModalContentWrapper>

			<ModalActions className="subscription-modal-actions">
				<Button variant="outline" label="close" onClick={closeModal} />
				{status === 'failed' && (
					<>
						<Button
							variant="blue"
							label={'returnToPaymentMethod'}
							onClick={() => {
								prevStep();
							}}
						/>
						<Button
							variant="blackOutline"
							css={css`
								text-decoration: underline;
								border: none !important;
							`}
							label="cancel"
							onClick={closeModal}
						/>
					</>
				)}
			</ModalActions>
		</>
	);
}
